import { createAsyncThunk } from '@reduxjs/toolkit';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { UserApiPaths } from '../../dataProvider/APIPaths';

export interface IStartTrial {
  email: string;
}

const TrialApiDataProvider = new APIDataProvider<{
  id: string;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  quizRole: string;
  isQuiztopiyaPendingTrial: boolean;
  assessmentEngineDate: string;
  quiztopiyaTrialExpiration: string;
}>();

export const startTrial = createAsyncThunk(
  'user/trial/create',
  async (data: IStartTrial) => {
    const response = await TrialApiDataProvider.create(
      UserApiPaths.trial,
      data
    );

    return response.data;
  }
);

export const getTrial = createAsyncThunk(
  '/trial-recordings/id',
  async (id: string) => {
    const response = await TrialApiDataProvider.getById(
      `${UserApiPaths.trialRecordings}/${id}`
    );

    return response.data;
  }
);

export default startTrial;
